import React, {useState, useEffect} from "react";
import axios from "axios";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import Card from "../../Components/Cards/Card";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";
import FileInput from "../../Components/Inputs/FileInput";
import swal from "sweetalert";
import {downloadBlob} from "../../Components/Helpers/Utils";

export default function () {

  const {handleSubmit, control, reset, watch} = useForm({
    defaultValues: {category_id: null, attributes: null}
  });

  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({});


  useEffect(() => {
      axios.get(`/all-categories`).then(res => {
        setCategories(res.data.categories);
      });
  }, []);
  const downloadProductAttributesTemplate = () => {
    if (watch('category_id')){
      axios.get(`/exports/product-attributes-template`, {
        params: {category_id: watch('category_id')},
        responseType: 'blob',
      }).then(res => {
        downloadBlob(res.data, 'product-attributes.csv');
      });
    } else{
      setErrors({...errors, category_id: 'Please select category'})
    }
  }

  const importProductAttributes = data => {
    let formData = new FormData;

    formData.append('category_id', data.category_id || '');
    formData.append('attributes', data.attributes || '');

    axios.post('/product/import/attribute-values', formData).then(res => {
      swal(res.data.message, {
        icon: "success",
      });

      reset({});
      setErrors({});
    }).catch(error => {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      } else {
        swal(error.message, {
          icon: "error",
        });
      }
    });
  }

  return (
    <Card title="Import product attributes">
      <button onClick={downloadProductAttributesTemplate}
              className="btn btn-primary me-2 mb-4 mt-1 download_product_template">
        <i className="fas fa-download"></i> Products attributes template
      </button>

      <form className="form w-100 row" onSubmit={handleSubmit(importProductAttributes)}>
        <ReactSelectInput
          label="Category"
          name="category_id"
          control={control}
          errorMessage={errors?.category_id}
          options={categories}
          inputClassName='mt-5'
          required={true}
        />

        <FileInput
          label="Products attributes"
          name="attributes"
          control={control}
          errorMessage={errors?.attributes}
        />

        <div className="col-12">
          <SubmitButton
            title="Import"
            classes="w-auto d-inline-block mt-3"
          />
        </div>
      </form>
    </Card>
  );
}